import { LoadingState } from '@orrekie/ui';

import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';

import { router } from './router';

/** Public auth routes (e.g. `/login`) are lazy in `routes.tsx` and sit outside `App`'s Suspense. */
function RouteFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <LoadingState label="Loading app…" />
    </div>
  );
}

export default function AppShell() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <RouterProvider router={router} />
    </Suspense>
  );
}
